import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <RankingSection />
        <FAQSection />
        <CarouselSection />
        <AppSection />
        <IndexSection />
        <CardsSection />
        <FeaturesSection />
        <MediaSection />
        <UpdatesSection />
        <CommentsSection />
        <AboutSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}